import { AssetManager } from "../../manager/AssetManager";
/**
 * SpineEventData.ts
 */
export class SpineEventData {
    constructor(data) {
        this.audioPath = data?.audioPath;
        this.balance = data?.balance;
        this.floatValue = data?.floatValue;
        this.intValue = data?.intValue;
        this.name = data?.name;
        this.stringValue = data?.stringValue;
        this.volume = data?.volume;
        this.audioId = AssetManager.getInstance().findAssetId(this.audioPath);
    }
    setAudioPath(_audioPath) {
        this.audioPath = _audioPath;
    }
    getAudioPath() {
        return this.audioPath;
    }
    setBalance(_balance) {
        this.balance = _balance;
    }
    getBalance() {
        return this.balance;
    }
    setFloatValue(_floatValue) {
        this.floatValue = _floatValue;
    }
    getFloatValue() {
        return this.floatValue;
    }
    setIntValue(_intValue) {
        this.intValue = _intValue;
    }
    getIntValue() {
        return this.intValue;
    }
    setName(_name) {
        this.name = _name;
    }
    getName() {
        return this.name;
    }
    setStringValue(_stringValue) {
        this.stringValue = _stringValue;
    }
    getStringValue() {
        return this.stringValue;
    }
    setVolume(_volume) {
        this.volume = _volume;
    }
    getVolume() {
        return this.volume;
    }
    setAudioId(_audioId) {
        this.audioId = _audioId;
    }
    getAudioId() {
        return this.audioId;
    }
}
//# sourceMappingURL=SpineEventData.js.map